var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rechner_wrapper"},[_c('RechnerTemplate',{attrs:{"steps":_vm.steps}},[_c('div',{attrs:{"slot":"success-info"},slot:"success-info"},[_vm._v("\n            Well done, all suceeded\n        ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }